// Carga "instantánea": una barra fina de progreso en lugar del círculo giratorio.
// Da sensación de respuesta inmediata sin el aspecto de lentitud del spinner.
export default function InstantLoader() {
  return (
    <div className="fixed inset-0 z-40 bg-ink overflow-hidden" aria-busy="true" aria-live="polite">
      <div
        className="absolute top-0 left-0 h-[2px] w-1/3 bg-cyan"
        style={{ animation: "instantbar 0.9s ease-in-out infinite" }}
      />
    </div>
  );
}